/**
 * スタッフページ専用i18n定数
 */

export const STAFF_LIST_I18N = {
  // ページタイトル・説明
  title: (userType: string) =>
    $localize`:@@admin.staffList.title:${userType}:userType:`,
  description: (userType: string) =>
    $localize`:@@admin.staffList.description:${userType}:userType:情報の閲覧・編集・停止・再開の設定を行います。`,
  contributorNote: $localize`:@@admin.staffList.contributorNote:多職種スタッフはユーザーひとりひとりに閲覧権限を割り当てるスタッフです。`,

  // アクション
  invite: (userType: string) =>
    $localize`:@@admin.staffList.invite:${userType}:userType:招待`,

  // フィルター
  filterPlaceholder: (userType: string) =>
    $localize`:@@admin.staffList.filterPlaceholder:${userType}:userType:氏名 フィルター`,

  // テーブルカラム
  columns: {
    name: $localize`:@@admin.staffList.columns.name:氏名`,
    jobTitle: $localize`:@@admin.staffList.columns.jobTitle:職種`,
    status: $localize`:@@admin.staffList.columns.status:ステータス`,
    createdAt: $localize`:@@admin.staffList.columns.createdAt:アカウント作成日`,
    info: $localize`:@@admin.staffList.columns.info:情報`,
    permission: $localize`:@@admin.staffList.columns.permission:権限`,
    suspend: $localize`:@@admin.staffList.columns.suspend:停止`,
  },

  // ステータス
  status: {
    active: $localize`:@@admin.staffList.status.active:有効`,
    inactive: $localize`:@@admin.staffList.status.inactive:無効`,
  },

  // ダイアログ
  dialog: {
    title: $localize`:@@admin.staffList.dialog.title:ダイアログ確認`,
    message: $localize`:@@admin.staffList.dialog.message:ダイアログが表示されます`,
  },
} as const;

export type StaffListI18n = typeof STAFF_LIST_I18N;
